const state = {
  visitedViews: []
}

const mutations = {
  ADD_VISITED_VIEW: (state, route) => {
    if (state.visitedViews.some(v => v.fullPath === route.fullPath)) return
    state.visitedViews.push({
      fullPath: route.fullPath,
      path: route.path,
      name: route.name,
      title: route.meta.title || '页面'
    })
  },
  DEL_VISITED_VIEW: (state, route) => {
    for (const [i, v] of state.visitedViews.entries()) {
      if (v.fullPath === route.fullPath) {
        state.visitedViews.splice(i, 1)
        break
      }
    }
  }
}

const actions = {
  addView({ commit }, route) {
    commit('ADD_VISITED_VIEW', route)
  },
  delView({ commit, state }, route) {
    return new Promise(resolve => {
      commit('DEL_VISITED_VIEW', route)
      resolve([...state.visitedViews])
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}